// @flow

// Modules
import styled, { css } from 'styled-components';

// Styles
import { BLUE_GREY, BLACK } from 'src/styles/palettes';
import { getFontSize } from 'src/styles/basestyle';
import { SCROLLBAR_WIDTH } from 'src/styles/scrollbar';

const LINE_HEIGHT = 1.85; // em
const LINE_MARGIN = 0.1; // em
const FONT_SIZE_MUTIPLIER = 0.9; // em
export const LINE_TOTAL_HEIGHT = (LINE_HEIGHT + LINE_MARGIN) * (getFontSize() * FONT_SIZE_MUTIPLIER);
export const PLACEHOLDER_POS = {
  BOTTOM: 'bottom',
  TOP: 'top'
};

const ListRow: any = styled.div`
  display: flex;
  align-items: center;
  height: ${LINE_HEIGHT}em;
  padding: 5px 10px;
  margin: ${LINE_MARGIN}em 0;
  margin-right: 1px;
  border-radius: 6px;
  font-size: ${FONT_SIZE_MUTIPLIER}em;
  font-weight: 600;
  color: ${(props) => props.color || (props.isPlayer && BLACK) || '#fff'};
  ${(props) => props.isClickable && 'cursor: pointer;'}
  background-color: ${(props) => (props.isPlayer ? props.colorBackground : BLUE_GREY[props.current ? 500 : 900])};

  :hover {
    background-color: ${(props) => (props.isPlayer ? props.colorBackground : BLUE_GREY[500])};
  }

  :first-child {
    margin-top: 0;
  }

  :last-child {
    margin-bottom: 0;
  }

  ${(props) =>
    props.position &&
    css`
      position: absolute;
      width: calc(100% - ${SCROLLBAR_WIDTH + 1}px);
      ${props.position === PLACEHOLDER_POS.TOP && `top: ${LINE_TOTAL_HEIGHT}px;`}
      ${props.position === PLACEHOLDER_POS.BOTTOM && 'bottom: 0;'}
      z-index: 30;
    `}
`;

export const SimpleRow: any = styled.div`
  flex: 1;
  padding: 20px;
  margin: 2px 0px;
  font-size: 0.7em;
  font-weight: 600;
  text-align: center;
`;

export default ListRow;
